<template>
    <div class="orderChildForm">
        <!-- :height="tableHeight" -->
        <el-table @selection-change="handleSelectionChange" :data="formData.doctorAdviceList" :key="randomKey" style="width: 100%">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="开始">
                <el-table-column align="center" label="日期|时间" width="150">
                    <template slot-scope="scope">
                        <div class="nurseDate">
                            <el-date-picker style="width:160px;" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="scope.row.startTime" type="datetime"></el-date-picker>
                        </div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="医生签名" width="90">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.startDoctorNo" clearable>
                        <el-option v-for="(item) in doctorData" :key="item.id" :label="item.menuName" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column align="center" label="临时医嘱">
                <template slot-scope="scope">
                    <div class="high">
                        <el-autocomplete type="textarea" autosize :highlight-first-item="true" v-model="scope.row.doctorAdvice" :fetch-suggestions="
                    (event, cb) => {
                      querySearchAsync(event, cb, scope.$index);
                    }
                  " placeholder="请输入关键字" :select-when-unmatched="true" @select="handleSelect($event,scope.$index)" prefix-icon="el-icon-user-solid">
                            <i class="el-icon-edit el-input__icon" slot="suffix">
                            </i>
                            <template slot-scope="{ item }">
                                <div class="careLevel" v-for="(list,index) in item.drugName.split(',')" :key="index">
                                    <div>{{list}}</div>
                                </div>
                                <span>{{item.drugUsage}}</span>
                            </template>
                        </el-autocomplete>
                        <div>
                            <el-button type="danger" icon="el-icon-delete" @click="delInfo(scope.$index, scope.row)"></el-button>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="执行时间" width="150">
                <template slot-scope="scope">
                    <div class="nurseDate">
                        <el-date-picker style="width:160px;" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="scope.row.executeTime" type="datetime"></el-date-picker>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="护士签名" width="90">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.stopNurseNo" clearable>
                        <el-option v-for="(item) in nurseData" :key="item.id" :label="item.menuName" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
        <div class="addButton">
            <el-button size="small" type="primary" icon="el-icon-plus" circle @click="add"></el-button>
            <el-button size="small" type="danger" icon="el-icon-minus" circle @click="del"></el-button>
        </div>
    </div>
</template>
<script>
import pinyin from 'pinyin-match'
import { mapState, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
export default {

    props: ['formData', 'doctorData', 'nurseData'],
    data() {
        return {
            tableHeight: 0,
            randomKey: Math.random(),
            multipleSelection: [],
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 280

    },
    computed: {
        ...mapGetters(["orderList",]),
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        querySearchAsync(queryString, cb, index) {
            var restaurants = this.orderList;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
            if (results.length == 0) {
                console.log('自己输入的值');
                console.log(this.formData.doctorAdviceList[index].doctorAdvice);
                this.formData.doctorAdviceList[index].doctorAdvice = queryString
                this.formData.doctorAdviceList[index].doctorAdviceNo = ''
            }
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                cb(results);
            }, 10 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
                state.value = state.drugName + ',' + state.drugUsage
                if (state.value) {
                    if (state.value.toUpperCase().indexOf(queryString.toUpperCase()) != -1) {
                        return true
                    }
                    // 输入值拼音d
                    return pinyin.match(state.value, queryString)
                }
            };
        },
        handleSelect(item, index) {
            // console.log(item, index);
            if (!item.id) {
                this.formData.doctorAdviceList[index].doctorAdvice = item.value
                this.formData.doctorAdviceList[index].doctorAdviceNo = ''
            } else if (item.id) {
                let reg = /[，,]/g
                let str = item.drugName + ',' + item.drugUsage
                this.formData.doctorAdviceList[index].doctorAdvice = str.replace(reg, '$&\r\n')
                this.formData.doctorAdviceList[index].doctorAdviceNo = item.id
            }
            // console.log(this.formData.doctorAdviceList[index].doctorAdvice);
            // console.log(this.formData.doctorAdviceList[index].doctorAdviceNo);
        },
        delInfo(index, row) {
            row.doctorAdvice = ''
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        add() {
            this.formData.doctorAdviceList.push({
                id: '',//主键id（修改需要传）
                startTime: '',//开始时间（年月日时分）
                startDoctorName: '',//医生签名（开始）
                startDoctorNo: '',//医生签名id（开始）
                startNurseName: '',//护士签名（开始）
                startNurseNo: '',//护士签名id（开始）
                doctorAdvice: '',//医嘱
                doctorAdviceNo: '',//医嘱id
                stopTime: '',//停止时间（月日时分）
                stopDoctorName: '',//医生签名（停止）
                stopDoctorNo: '',//医生签名id（停止）
                executeTime: '',//执行时间
                stopNurseName: '',//护士签名（停止）
                stopNurseNo: '',//护士签名id（停止）
                uuid: uuidv4()
            })
        },
        del() {
            if (this.multipleSelection.length == 0) {
                _g.toast('warning', '请先选择要删除的医嘱!!!')
                return;
            } else {
                this.formData.doctorAdviceList = this.formData.doctorAdviceList.filter(item => !this.multipleSelection.some(ele => ele.uuid === item.uuid));

            }
        },
        orderMatch(val) {
            this.orderDatas = _g.drugMatch(this.orderList, this.orderDatas, val, 'drugName', 'drugUsage')
        },
    }
}
</script>
<style>
.el-select-dropdown__item {
  height: auto !important;
  line-height: auto !important;
  line-height: 30px;
  /* margin-bottom: 5px; */
}
</style>

<style scoped>
.careLevel {
  color: #000;
  font-size: 14px !important;
}
.drugUsage {
  font-size: 14px;
  color: #b4b4b4;
}
.orderChildForm >>> .el-table td,
.el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.orderChildForm >>> .el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.orderChildForm >>> .el-input__inner {
  height: 30px !important;
  line-height: 30px;
  padding: 0 !important;
  box-sizing: border-box;
  border: none;
  text-align: center;
}
.orderChildForm >>> .cell {
  padding: 0 !important;
}
.orderChildForm >>> .el-select__tags {
  overflow: scroll;
  flex-wrap: nowrap;
  max-width: 200px !important;
}
.orderChildForm >>> .el-input__icon {
  display: none;
}
.nurseDate >>> .el-input__icon {
  line-height: 30px !important;
}
.addButton {
  float: right;
}
.high >>> .el-autocomplete {
  width: 100% !important;
}
.high >>> .el-button {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.high {
  margin: 0 auto;
  display: flex;
  align-items: center;
}
</style>


